import { ProgressBar } from '@datacloud-incubation/frontend-common-library';
import NotificationsWrapper from '@datacloud-incubation/frontend-notifications-module';
import { splittersRegistryService } from '@datacloud-incubation/frontend-splitter-module';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense } from 'react';
import { RouterProvider } from 'react-router';
import { SplitterId } from '@constants/common.constant';
import { tanstackQueryService } from '@core/services/TanstackQuery.service';
import { router } from '@routes/router';
import { useApp } from './hooks/useApp';
import './index.css';

splittersRegistryService.registerSplitters(Object.values(SplitterId));

const App = () => {
  const { isShownRouterProvider } = useApp();

  const routerProvider = isShownRouterProvider ? null : <RouterProvider router={router()} />;

  return (
    <>
      <NotificationsWrapper />
      <QueryClientProvider client={tanstackQueryService.queryClient}>
        <Suspense fallback={<ProgressBar />}>{routerProvider}</Suspense>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
};

export default App;
